import { PaasTenant } from './paas-tenant'
import Content from '@/pages/content'
import MContent from '@/pages/m-content'

/**
 * 动态路由
 */
class AsyncRoute {
    static data = []

    static async getAsyncRoute() {
        if (AsyncRoute.data.length === 0) {
            const tenantInfo = await PaasTenant.getTenantInfo()
            if(tenantInfo.subSystem) {
                if(tenantInfo.subSystem.includes(1)) {
                    // 资源系统
                    const arr = [
                        {
                            path: '/resource-list',
                            name: 'ResourceList',
                            meta: {
                                pageMode: 'header-nav'
                            },
                            component: () => import('@/pages/resource-manager/resource-list')
                        },
                        {
                            path: '/resource-detail/:id',
                            name: 'ResourceDetail',
                            meta: {
                                pageMode: 'header-nav'
                            },
                            component: () => import('@/pages/resource-manager/resource-detail')
                        },
                        {
                            path: '/personal',
                            name: 'Personal',
                            meta: {
                                pageMode: 'header-nav'
                            },
                            component: () => import('@/pages/personal')
                        },
                    ]
                    AsyncRoute.data = AsyncRoute.data.concat(arr)
                }
                if(tenantInfo.subSystem.includes(2)) {
                    // 会员系统
                    const arr = [
                        {
                            path: '/member-home',
                            name: 'MemberHome',
                            meta: {
                                pageMode: 'header-nav'
                            },
                            component: () => import('@/pages/member-home/index.vue')
                        },
                        {
                            path: '/preview-certificate',
                            name: 'PreviewCertificate',
                            component: () => import('@/components/member-home/preview.vue')
                        },
                        {
                            path: '/personal',
                            name: 'Personal',
                            meta: {
                                pageMode: 'header-nav'
                            },
                            component: () => import('@/pages/personal')
                        },
                    ]
                    AsyncRoute.data = AsyncRoute.data.concat(arr)
                }
            }
            const res = await PaasTenant.getRouters()
            res.forEach(r => {
                r.component = Content
                r.meta = {
                    pageMode: 'paas-page'
                }
            })
            const resM = await PaasTenant.getRoutersM()
            resM.forEach(r => {
                r.component = MContent
                r.meta = {
                    pageMode: 'paas-page'
                }
            })
            AsyncRoute.data = AsyncRoute.data.concat([...res,...resM])
            return AsyncRoute.data
        } else {
            return AsyncRoute.data
        }
    }

    static isExist() {
        return AsyncRoute.data.length !== 0
    }
}

export {
    AsyncRoute
}


// WEBPACK FOOTER //
// ./src/models/async-route.js